// extracted by mini-css-extract-plugin
module.exports = {"topDescription":"az_Xtc","topDescriptionExpanded":"az_Ytc","topDescriptionExpandButton":"az_Ztc"};